import { createBrowserRouter } from "react-router-dom";

import App from "./App";
import './components/main.css'

import React from 'react';

import PrivateRoute from "./privateRoute";

import Dashboard from "./components/dashboard";

import Fabric from './components/fabric';
import Suits from './components/Suits';
import View_Fabric from './components/ViewFabric';
import Order_page from './components/order_page';
import UpdateFabric from './components/updatingFabrics';
import AddBrand from './components/addBrand';
import Presets_upload from './components/Presets';
import Login from "./login";
import Admin from "./Admin";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/login",
        element: <div className=''>    
    <Login/>
              
                </div>
      },
      
      {
        path: "/",
        element: <div className=''>    
    <Dashboard/>
              
                </div>
      },
      {
        path: "/admin/:id?",
        element: (
            <PrivateRoute>
                <Admin/>
            </PrivateRoute>
          )
      }
    ]
  }
]);

export default router;
